import {ArticleProductionStepSearchReplyListElement} from './article-steps-copy.models';
import {clsx} from 'clsx';
import {ArticleLabel} from '../label/article-label';
import {appHref} from '../../../helper/app-href';

interface Props {
  element: ArticleProductionStepSearchReplyListElement;
  isSelected: boolean;
  onSelect: () => void;
}

export function ArticleStepsSearchListRow(props: Props) {
  return <>
    <div className={clsx(
      {
        'bg-white': !props.isSelected,
        'bg-storz-green-select': props.isSelected,
      },
      'grid',
      'col-span-4',
      'grid-cols-4',
      'grid-rows-subgrid',
      'border',
      'border-solid',
      'border-whitetable-border',
      'border-b-0',
      'cursor-pointer',
    )}
         onClick={() => props.onSelect()}>
      <div className="p-2">
        <ArticleLabel isDeleted={props.element.isDeleted}
                      isLocked={props.element.isLocked}/>
      </div>
      <div className="p-2">
        {props.element.oaNr}
      </div>
      <div className="p-2">
        {props.element.sdsNr}
      </div>
      <div className="p-2">
        <a href={appHref(`/article/production/${props.element.oaNr}`)}
           title="Artikel in neuem Fenster / Tab öffnen"
           target="_blank">
          <i className="fa fa-qrcode"/>
        </a>
      </div>
    </div>
  </>;
}
